/**
 * N.B. The confetti code hasn't been removed from this container because I want it to be put back soon :)
 * Just the `ConfettiCannon` component has been removed from the app container.
 *
 *
 *
 * @author Matthew Rawson @ 21/02/2018 10:07
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import connect from "@irati/store/connect"
import {H2, H3} from "@irati/ui/src/Headings"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {userSurveyTracking} from "@irati-tracking/insights"
import Anchor from "@irati/ui/src/Link/styled/Anchor"
import ButtonCss from "@irati/ui/src/Button/styled"

import FinishSvg from "./Finish.svg"
import {fireConfettiCannon} from "../../store/actions/confetti"


const FinishImg = styled.img`
  width: 100px;
  height: 100px;
  ${minWidthMedia.tablet`
    width: auto;
    height: auto;
  `}
`


const FinishWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 30px;

  > * {
    margin-bottom: 25px;

    &:last-child {
      margin-top: 15px;
    }
  }

  ${minWidthMedia.tablet`
    padding-top: 60px;


    > * {
      margin-bottom: 30px;
    }
  `}
`

const ButtonAnchor = styled(Anchor)`
  ${ButtonCss}
  display: block;
  margin: 20px 0;
`


class Finish extends Component {
  static propTypes = {
    userSurvey: PropTypes.object,
    fireConfettiCannon: PropTypes.func.isRequired,
    isReturningUser: PropTypes.bool,
    tenantName: PropTypes.string
  };
  static defaultProps = {
    userSurvey: {},
    isReturningUser: false,
    tenantName: ""
  };

  componentDidMount() {
    const {userSurvey, isReturningUser} = this.props
    userSurveyTracking.finished({userSurvey, isReturningUser})

    /** Fire the double completed cannon :) */
    const rightCannon = [
      {x: window.innerWidth, y: window.innerHeight},
      {x: window.innerWidth * 1.3, y: window.innerHeight * 1.6}
    ]
    const leftCannon = [
      {x: 0, y: window.innerHeight},
      {x: -(window.innerWidth * 0.3), y: window.innerHeight * 1.6}
    ]

    setTimeout(() => {
      this.props.fireConfettiCannon(rightCannon)
      setTimeout(() => (
        this.props.fireConfettiCannon(leftCannon)
      ), 300)
    }, 300)
  }

  render() {
    const idNamespace = id("welcome", this.props)
    const {userSurvey, isReturningUser, tenantName} = this.props
    const showActionBoardLink = userSurvey && userSurvey.preferences.includeActionBoard

    return (
      <div id={idNamespace}>
        <FinishWrapper id={id("wrapper", idNamespace)}>
          <FinishImg src={FinishSvg} alt="User survey start" />
          <H2 id={id("title", idNamespace)}>
            {!isReturningUser && <span><FormattedMessage id="insights.finishedSurvey.heading.thanks" /></span>}
            {isReturningUser && <span><FormattedMessage id="insights.finishedSurvey.heading.returningUser" /></span>}
          </H2>

          {showActionBoardLink && (
            <H3 id={id("sub-title", idNamespace)}>
              <FormattedMessage id="insights.finishedSurvey.heading.subTitle" />
            </H3>
          )}

          {showActionBoardLink && (
            <ButtonAnchor
              primary
              href={userSurvey.preferences.actionBoardUrl}
              alt="Trello action board"
              target="_BLANK">
              <FormattedMessage id="insights.finishedSurvey.showActionBoard" values={{tenantName}} />
            </ButtonAnchor>
          )}
        </FinishWrapper>
      </div>
    )
  }
}


export const mapDispatchToProps = (dispatch) => {
  return {
    fireConfettiCannon: (vector) => dispatch(fireConfettiCannon(vector))
  }
}

export default injectIntl(connect(null, mapDispatchToProps)(Finish))
